import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
    {
        title: "Professional, Transparent, and Reliable",
        message: "I've invested in mutual funds and bonds through this platform and have always found the team to be professional and knowledgeable. Their guidance has helped me grow my portfolio with confidence.",
        name: "Anjali Mehta",
        location: "Ahmedabad"
    },
    {
        title: "Trusted Financial Partner",
        message: "The research analyst team provides in-depth market insights that have helped me make smarter investment decisions. I also appreciate their support for global access and alternative investment options.",
        name: "Rajesh Patel",
        location: "Mumbai"
    },
    {
        title: "Excellent Customer Support",
        message: "Whenever I had a doubt or issue, the team responded quickly and with helpful advice. Their service is top-notch!",
        name: "Sneha Reddy",
        location: "Hyderabad"
    },
    {
        title: "Great Returns!",
        message: "My investments have grown consistently thanks to their expert guidance. Highly recommended for serious investors.",
        name: "Karan Shah",
        location: "Pune"
    },
    {
        title: "User-Friendly Platform",
        message: "Navigating and using the investment tools is so easy even for beginners like me. Love the interface!",
        name: "Priya Desai",
        location: "Bangalore"
    },
    {
        title: "Secure and Transparent",
        message: "Security was my top concern and this platform delivered. Everything is clear and trustworthy.",
        name: "Vikram Jain",
        location: "Delhi"
    }
];

const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
};

const Testimonial = () => {
    return (
        <div className="testimonial-section py-5">
            <div className="container">
                <h2 className="text-center mb-5">Why Choose GPS Finvest?</h2>
                {/* <Slider {...settings}>
                    {testimonials.map((item, index) => (
                        <div key={index} className="testimonial-card p-4">
                            <div className="bg-white shadow rounded p-4 h-100 d-flex flex-column justify-content-between">
                                <h5 className="mb-3 text-primary">"{item.title}"</h5>
                                <p className="text-muted">{item.message}</p>
                                <p className="fw-bold mt-3 mb-0">- {item.name}, {item.location}</p>
                            </div>
                        </div>
                    ))}
                </Slider> */}
            </div>
            <div className="container">
                <div className="why-gps-container d-flex flex-wrap align-items-center justify-content-between py-4">
                    <div className="text-section" style={{ flex: '1 1 50%', paddingRight: '20px' }}>
                        <h2 className="mb-4">Why Choose GPS Finvest?</h2>
                        <ul className="list-unstyled">
                            <li className="mb-2">🔹 Personalized, goal-based investment planning</li>
                            <li className="mb-2">🔹 SEBI-registered experts and advisory</li>
                            <li className="mb-2">🔹 Transparent pricing with no hidden charges</li>
                            <li className="mb-2">🔹 Digital onboarding & real-time investment tracking</li>
                            <li className="mb-2">🔹 Access to global and alternative markets</li>
                        </ul>
                    </div>
                    <div className="image-section" style={{ flex: '1 1 45%' }}>
                        <img
                            src="images/Image.png"
                            alt="About Us"
                            className="img-fluid rounded shadow"
                            style={{ width: '100%', maxWidth: '500px' }}
                        />
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Testimonial;
